import React, { CSSProperties } from 'react'

import {
  Body1,
  Box,
  Button,
  ButtonVariant,
  Color,
  Body2,
  Image,
  RadiusScale,
  useTheme,
  Display,
} from '@gousto-internal/citrus-react'

import { MenuApiPreferencesResponse } from '@library/menu-service'
import { MenuRecipe } from '@library/menu-service/queries/common/types'

const IMAGE_WIDTH = 200

type SearchRecipeTileProps = {
  recipe: MenuRecipe
  menuPreferences?: MenuApiPreferencesResponse
}
const SearchRecipeTile = ({ recipe, menuPreferences }: SearchRecipeTileProps) => {
  const { theme } = useTheme()
  const recipeImage = recipe.images[0].crops.find(({ width }) => width === IMAGE_WIDTH)

  return (
    <Box display={Display.Flex}>
      <Box borderRadius={1}>
        {recipeImage ? (
          <Image
            alt={recipe.name}
            src={recipeImage.url}
            width="120px"
            height="120px"
            style={{ ...(theme.radius(2 as RadiusScale) as CSSProperties) }}
            data-testid="search-recipe-tile"
          />
        ) : (
          <Box width="120px" height="120px" />
        )}
      </Box>
      <Box flexGrow={1} paddingH={4}>
        <Body1 fontWeight={700} color={Color.ColdGrey_800}>
          {recipe.name}
        </Body1>
        <Box display={Display.Flex}>
          <Body2>{`${recipe.prep_time} mins`}</Body2>
          {(!menuPreferences || menuPreferences?.display_calories) && (
            <Body2>
              &nbsp;&nbsp;|&nbsp;&nbsp;
              {`${recipe.nutritional_information.per_portion.energy_kcal}kcal`}
            </Body2>
          )}
        </Box>
      </Box>
      <Box>
        <Button variant={ButtonVariant.Icon} icon="add" />
      </Box>
    </Box>
  )
}

export { SearchRecipeTile }
